import {
  PosthogCustomProvider,
  WithPosthogIdentify,
} from "@v2/shared/lib/posthog";
import { Outlet } from "react-router";
import { WithPaywallIframeMessenger } from "./paywallIframeMessenger.wrap";
import { UnderMaintenanceGuard } from "./underMaintenanceGuard.wrap";

export function MainContentGuard() {
  return (
    <PosthogCustomProvider>
      <WithPosthogIdentify>
        <UnderMaintenanceGuard>
          <WithPaywallIframeMessenger>
            <Outlet />
          </WithPaywallIframeMessenger>
        </UnderMaintenanceGuard>
      </WithPosthogIdentify>
    </PosthogCustomProvider>
  );
}
